// Bus Channel Route

const Bus = () => import(/* webpackChunkName: "Bus" */ '../views/Bus')
const BusCampaignEditor = () => import(/* webpackChunkName: "Bus" */ '../views/Bus/CampaignEditor')
const BusCampaignEditorBrowse = () => import(/* webpackChunkName: "Bus" */ '../views/Bus/CampaignEditor/Browse')
const CampaignOrderDetail = () => import(/* webpackChunkName: "Bus" */ '../views/Bus/CampaignOrderDetail')
//Order Execution
const OrderExecution = () => import(/* webpackChunkName: "OrderExecution" */ '../views/Execution')
const AllOrder = () => import(/* webpackChunkName: "OrderExecution" */ '../views/Execution/AllOrder')
const OrderPayment = () => import(/* webpackChunkName: "OrderPayment" */ '../views/Execution/Payment')
const OrderActive = () => import(/* webpackChunkName: "OrderActive" */ '../views/Execution/Active')
const OrderCanceled = () => import(/* webpackChunkName: "OrderCanceled" */ '../views/Execution/Canceled')
const OrderExpired = () => import(/* webpackChunkName: "OrderExpired" */ '../views/Execution/Expired')
const OrderDormant = () => import(/* webpackChunkName: "OrderDormant" */ '../views/Execution/Dormant')
// Order Detail
const OrderDetailExecution = () => import(/* webpackChunkName: "OrderDetailExecution" */ '../views/Execution/OrderDetail')
const Discussion = () => import(/* webpackChunkName: "Discussion" */ '../views/Execution/OrderDetail/Discussion')
const CreativeFile = () => import(/* webpackChunkName: "CreativeFile" */'../views/Execution/OrderDetail/CreativeFile')
const Mockup = () => import(/* webpackChunkName: "Mockup" */ '../views/Execution/OrderDetail/Mockup')
const Bast = () => import(/* webpackChunkName: "Bast" */ '../views/Execution/OrderDetail/Bast')

//New Result Bus
const ResultPageBus = () => import(/* webpackChunkName: "Bus" */ '../views/ResultPage/Bus')

//New Detail Page
const DetailPageBus = () => import(/* webpackChunkName: "Bus" */ '../views/DetailPage/Bus')


const busRoute = [
    // {
    //   path: '/bus',
    //   name: 'bus',
    //   component: Bus
    // },
    {
      path: '/bus/campaigneditor/:id',
      name: 'buscampaigneditor',
      component: BusCampaignEditor,
      meta: { requiresAuth: true }
    },
    {
      path: '/bus/campaigneditor/:id/browse',
      name: 'buscampaigneditorbrowse',
      component: BusCampaignEditorBrowse,
      meta: { requiresAuth: true }
    },
    {
      path: '/bus/campaignorderdetail/:id',
      name: 'campaignorderdetail',
      component: CampaignOrderDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/orderexecution',
      name: 'orderexecution',
      component: OrderExecution,
      props: true,
      meta:{ isAdminBus: true, requiresAuth: true },
      redirect: { name: 'allorder' },
      children: [
        {
          path: 'allorder',
          name: 'allorder',
          component: AllOrder,
          meta: { requiresAuth: true}
        },
        {
          path: 'payment',
          name: 'orderpayment',
          component: OrderPayment,
          meta: { isAdminBus: true, requiresAuth: true}
        },
        {
          path: 'active',
          name: 'orderactive',
          component: OrderActive,
          meta: { requiresAuth: true}
        },
        {
          path: 'canceled',
          name: 'ordercanceled',
          component: OrderCanceled,
          meta: { requiresAuth: true}
        },
        {
          path: 'expired',
          name: 'orderexpired',
          component: OrderExpired,
          meta: { requiresAuth: true}
        },
        {
          path: 'dormant',
          name: 'orderdormant',
          component: OrderDormant,
          meta: { requiresAuth: true}
        },
      ],
    },
    {
      path: '/orderdetailexecution/:id',
      name: 'orderdetailexecution',
      component: OrderDetailExecution,
      props: true,
      meta: { requiresAuth: true },
      redirect: { name: 'discussion' },
      children: [
        {
          path: 'discussion',
          name: 'discussion',
          component: Discussion,
          meta: { requiresAuth: true }
        },
        {
          path: 'creativefile',
          name: 'creativefile',
          component: CreativeFile,
          meta: { requiresAuth: true }
        },
        {
          path: 'mockup',
          name: 'mockup',
          component: Mockup,
          props: true,
          meta: { requiresAuth: true }
        },
        {
          path: 'bast',
          name: 'bast',
          component: Bast,
          props: true,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/results/bus/:id?',
      name: 'bus',
      component: ResultPageBus,
    },
    {
      path: '/detail-result/:campaignId?/bus/:id',
      name: 'detailpagebus',
      component: DetailPageBus,
    },
]

export default busRoute;
